/** 瀏覽器能直接打開的副檔名。 */

const IMAGE_EXT = new Set(['png', 'jpg', 'jpeg', 'gif', 'webp', 'bmp', 'svg', 'tif', 'tiff']);
const RASTER_IMAGE_EXT = new Set(['png', 'jpg', 'jpeg', 'gif', 'webp', 'bmp', 'tif', 'tiff']);
const RAW_EXT = new Set([
  'raf', 'cr2', 'cr3', 'nef', 'nrw', 'arw', 'srf', 'sr2',
  'dng', 'rw2', 'orf', 'pef', 'raw', 'rwl', '3fr', 'erf',
  'kdc', 'mos', 'mrw', 'x3f',
]);
/** HTML5 <video> 常見能播的容器（不保證裡面的 codec）。 */
const NATIVE_VIDEO_EXT = new Set(['mp4', 'm4v', 'webm', 'ogv']);
/** 可向後端要縮圖的影片（含 mkv；播放仍看 isNativeVideoFile）。 */
const VIDEO_THUMB_EXT = new Set(['mp4', 'm4v', 'webm', 'ogv', 'mkv']);
/** HTML5 <audio> 常見能播的（Safari 對 ogg/flac 可能失敗）。 */
const NATIVE_AUDIO_EXT = new Set(['mp3', 'm4a', 'aac', 'wav', 'ogg', 'opus', 'flac']);
const PDF_EXT = new Set(['pdf']);

function extensionOf(name: string): string {
  const base = name.includes('/') ? name.slice(name.lastIndexOf('/') + 1) : name;
  const dot = base.lastIndexOf('.');
  if (dot <= 0 || dot === base.length - 1) {
    return '';
  }
  return base.slice(dot + 1).toLowerCase();
}

export function fileBasename(path: string): string {
  const cleaned = path.replace(/\/+$/, '');
  const idx = cleaned.lastIndexOf('/');
  return idx >= 0 ? cleaned.slice(idx + 1) : cleaned;
}

export function isImageFile(name: string): boolean {
  return IMAGE_EXT.has(extensionOf(name)) || isRawFile(name);
}

export function isRasterImageFile(name: string): boolean {
  return RASTER_IMAGE_EXT.has(extensionOf(name)) || isRawFile(name);
}

export function isRawFile(name: string): boolean {
  return RAW_EXT.has(extensionOf(name));
}

export function isNativeVideoFile(name: string): boolean {
  return NATIVE_VIDEO_EXT.has(extensionOf(name));
}

export function isVideoFile(name: string): boolean {
  return VIDEO_THUMB_EXT.has(extensionOf(name));
}

export function isNativeAudioFile(name: string): boolean {
  return NATIVE_AUDIO_EXT.has(extensionOf(name));
}

export function isPdfFile(name: string): boolean {
  return PDF_EXT.has(extensionOf(name));
}

export function isOnlineOpenable(name: string): boolean {
  return (
    isImageFile(name) ||
    isNativeVideoFile(name) ||
    isNativeAudioFile(name) ||
    isPdfFile(name)
  );
}
